import React, { useState } from 'react';
import NavigationHeader from '../_navigation/ThickNavigation/NavigationHeader';
import NavigationGroup from '../_navigation/ThickNavigation/NavigationGroup';
import SidebarNavigationGrouped from './SidebarNavigationGrouped';
import SidebarNavigation from './SidebarNavigation';
import { ChevronDoubleLeftIcon } from "@heroicons/react/24/outline";

export default function Sidebar(props) {
  const { navigation = [], title, grouped = false, header } = props;
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className={`hidden lg:block z-10 duration-300`} style={{ transitionProperty: "width", width: collapsed ? '1rem' : '18rem' }}>
      <nav className="flex flex-col -mr-0.5 border-r-2 border-cs-gray-100 py-8 bg-white overflow-y-auto h-screen space-y-8 relative">
        {/*<div className="hidden lg:flex lg:flex-shrink-0 bg-white">*/}
        {/*  <div className="flex flex-col w-64 border-r border-gray-200 space-y-8">*/}
        {title && (
          <NavigationGroup>
            <NavigationHeader>
              {title}
            </NavigationHeader>
            <button onClick={toggleCollapse}><ChevronDoubleLeftIcon className={`hover:bg-cs-blue-900 text-cs-gray-100 rounded-full w-2 inline-block absolute top-1 left-1 transition-all ${collapsed ? 'rotate-180' : ''}`}/></button>
          </NavigationGroup>
        )}
        {header}
        {grouped ? (
          <SidebarNavigationGrouped navigation={navigation} />
        ) : (
          <SidebarNavigation navigation={navigation} />
        )}
      </nav>
    </div>
  )
}
